const Validation = require('./validation')
module.exports = class PostalCode extends Validation {}
